module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-dialog-modal', {
    ref: "deleteModal",
    attrs: {
      "title": 'Verwijder ' + _vm.title
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n\t\t\t\tWeet u zeker dat u " + _vm._s(_vm.deleteName) + " wilt verwijderen?\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "block": ""
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("\n\n\t\t\t\t\t" + _vm._s(_vm.cancelButtonText) + "\n\n\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "type": "button",
      "disabled": _vm.isDeleting,
      "block": "",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_c('loader-spinner', {
    attrs: {
      "text": _vm.confirmButtonText,
      "show-spinner": _vm.isDeleting
    }
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f2aa268"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Edit/DeleteDialogModal.vue
// module id = 1316
// module chunks = 1